import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5468d8c1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { key: 1 }

import { useI18n } from 'vue-i18n'
import { computed, ref } from 'vue'
import { RequestResponse } from '../../../types/index'


export default /*#__PURE__*/_defineComponent({
  __name: 'RequestStatus',
  props: {
  response: {
    type: Object as () => RequestResponse,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props

const { t } = useI18n()

const requestFailed = computed(() => {
  if (props.response?.success != null) {
    return !props.response?.success
  } else {
    return false
  }
})

const errorMessage = computed(() => {
  return (
    props.response?.message ??
    'Irgendwas ist schiefgelaufen. Bitte versuchen sie es nochmals'
  )
})

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            color: "green"
          })
        ]))
      : _createCommentVNode("", true),
    (requestFailed.value && !__props.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_v_alert, {
            color: "red",
            theme: "dark",
            icon: "mdi-close-octagon",
            border: "",
            align: "center"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(errorMessage.value), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})